import React, { useEffect, useState } from "react";

const useSearchFilter = (sourceData, search, key = "room_name") => {
  const [filteredData, setFilteredData] = useState(sourceData);

  useEffect(() => {
    if (!search) {
      setFilteredData(sourceData);
    } else {
      const result = (sourceData?.data ?? []).filter((item) =>
        item[key]?.toLowerCase().includes(search.toLowerCase())
      );

      setFilteredData({
        ...sourceData,
        data: result,
      });
    }
  }, [search, sourceData, key]);

  return filteredData;
};

export default useSearchFilter;
